// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"8738b8b2","724":"e898ba74"}[chunkId] + ".chunk.js";
};